import { createElementBlock as t, openBlock as l, createElementVNode as h } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(r, e) {
  return l(), t("svg", n, e[0] || (e[0] = [
    h("path", {
      fill: "#512BD4",
      d: "M22 2H2v20h20z"
    }, null, -1),
    h("path", {
      fill: "#fff",
      d: "M5.565 14.778a.5.5 0 0 1-.361-.142.47.47 0 0 1-.148-.344.47.47 0 0 1 .148-.348.5.5 0 0 1 .36-.145q.216 0 .365.145a.46.46 0 0 1 .152.348.46.46 0 0 1-.152.344.5.5 0 0 1-.364.142m5.653-.08h-.92l-2.421-3.82a1.7 1.7 0 0 1-.152-.301h-.021q.028.166.028.714v3.407h-.813V9.5h.98l2.34 3.73q.148.232.19.319h.015a5 5 0 0 1-.036-.7V9.5h.81zm3.96 0h-2.846V9.5h2.732v.732h-1.89v1.472h1.742v.728h-1.743v1.537h2.005zm4.044-4.466h-1.456v4.466h-.842v-4.466h-1.453V9.5h3.751z"
    }, null, -1)
  ]));
}
const a = { render: o };
export {
  a as default,
  o as render
};
